<template>
  <div class="informe-general">
    <v-container fluid>
      <v-card>
        <v-card-title class="secondary--text">
          Generar Informe General
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-toolbar-title justify="center"
            align="center"
            class="display-1">
           <span class="text-h6 "> {{ getContrato.numero }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-container>
            <v-row>
              <v-col justify="center"
                align="center" cols='12' class='d-flex'>
                  <date-picker
                    v-model="fechaDelInforme"
                    label="Del"
                    cols="6"
                    dense>
                </date-picker>

                <date-picker
                    v-model="fechaAlInforme"
                    label="Al"
                    cols="6"
                    dense>
                </date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col justify="center"
                align="center" cols='12' class='d-flex'>
                <custom-text-field
                      cols="12"
                      v-model="numeroInforme"
                      label="Número del Informe"
                     >
                    </custom-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-container >
            <v-row >
              <v-col>
                <v-list
                density="compact"
                dense
                flat
                nav >
                  <v-list-item
                    v-for="(documento, index) in documentosList"
                    :key="index"
                    :documento="documento.nombre">
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="documento.nombre">
                      </v-list-item-title>
                    </v-list-item-content>
                      <v-list-item-action >

                        <v-tooltip bottom color="verde2">
                          <template v-slot:activator="{ on, attrs }">
                            <custom-button
                              :disabled="documento.disabled"
                              class="mx-2"
                              label=""
                              iconText="mdi-cloud-download"
                              tipo="agregar"
                              v-bind="attrs"
                              v-on="on"
                              :loading="documentoSeleccionado===documento.id"
                              @click="seleccionaDocumento(documento)">
                            </custom-button>
                          </template>
                          <span >Genera Documento</span>
                        </v-tooltip>
                      </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATOACTIVIDADESTODAS from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividadesTodas.gql';
import CONTRATOSINVENTARIOS from '@/graphql/querys/administracion/contratos/contrato/inventario/contratosInventarios.gql';
import CONTRATOSDIRECTORIOS from '@/graphql/querys/administracion/contratos/contrato/directorio/contratosDirectorios.gql';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import mixPdfDatosGenerales from './mixPdfDatosGenerales';
import mixPdfActividades from './mixPdfActividades';
import mixPdfReporteFotografico from './mixPdfReporteFotografico';
import mixPdfMaquinariaYEquipo from './mixPdfMaquinariaYEquipo';
import mixPdfGraficaAvances from './mixPdfGraficaAvance';
import mixPdfDirectorio from './mixPdfDirectorio';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

export default {
  name: 'InformeGeneral',
  mixins: [
    mixGenerarPdf,
    mixFormatoEstructura,
    mixPdfDatosGenerales,
    mixPdfActividades,
    mixPdfReporteFotografico,
    mixPdfMaquinariaYEquipo,
    mixPdfGraficaAvances,
    mixPdfDirectorio],
  props: {
    idContrato: {
      type: String,
      required: true,

    },
  },
  components: {
    CustomButton,
    DatePicker,
    CustomTextField,
  },
  data() {
    return {
      fechaDelInforme: '',
      fechaAlInforme: '',
      numeroInforme: '',
      generandoPdfInformeGeneral: false,
      documentoSeleccionado: null,
      documentosList: [
        { id: 1, nombre: 'Datos Generales', disabled: false },
        { id: 2, nombre: 'Actividades Realizadas', disabled: false },
        { id: 3, nombre: 'Relación de maquinaria y equipo', disabled: false },
        { id: 4, nombre: 'Reporte fotográfico', disabled: false },
        { id: 5, nombre: 'Gráfica de avance', disabled: false },
        { id: 6, nombre: 'Directorio de Obra', disabled: false },
      ],
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
    contratoActividadesTodas: {
      query: CONTRATOACTIVIDADESTODAS,
    },
    contratosInventarios: {
      query: CONTRATOSINVENTARIOS,
    },
    contratosDirectorios: {
      query: CONTRATOSDIRECTORIOS,
    },
  },
  mounted() {
    const hoy = new Date();
    this.fechaDelInforme = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
      .toISOString().slice(0, 10);
    /*
    this.fechaAlInforme = new Date(hoy.getFullYear(),
      hoy.getMonth() + 1, 0);
    this.fechaAlInforme = this.fechaAlInforme.toISOString().slice(0, 10); */
    this.fechaAlInforme = new Date().toISOString().slice(0, 10);
    this.AlaFecha = this.fechaAlInforme;
  },
  computed: {
    getContratosDirectorios() {
      if (!this.contratosDirectorios) return [];
      return this.contratosDirectorios;
    },
    getContratosInventarios() {
      if (!this.contratosInventarios) return [];
      return this.contratosInventarios;
    },
    getContratoActividadesTodas() {
      if (!this.contratoActividadesTodas) return [];
      return this.contratoActividadesTodas;
    },
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getCliente() {
      if (!this.contrato.cliente) return {};
      const cliente = this.contrato.cliente || {};
      return cliente;
    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrarGenerarPdfInformeGeneral');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    seleccionaDocumento(documento) {
      if (documento.id >= 1 && documento.id <= 6
      && (this.fechaDelInforme && this.fechaAlInforme)) {
        this.AlaFecha = this.fechaAlInforme;
        this.documentoSeleccionado = documento.id;
        switch (documento.id) {
          case 1:
            this.generarPdfDatosGenerales();
            break;
          case 2:
            this.generarPdfActividades();
            break;
          case 3:
            this.generarPdfMaquinariaYEquipo();
            break;
          case 4:
            this.generarPdfReporteFotografico();
            break;
          case 5:
            this.generarPdfGraficaAvances();
            break;
          case 6:
            this.generarPdfDirectorio();
            break;

          default: break;
        }
      }
    },

  },
};
</script>
